import { authFetch } from '@/lib/auth/authFetch';
import { API_BASE_URL } from '@/utils/api';
import logger from '@/utils/logger';

const API_URL = `${API_BASE_URL}/fan-badges`;

export async function getFanBadgesByUserID(userID, token) {
  try {
    const response = await authFetch(`${API_URL}/user/${userID}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    logger.error(error);
    throw error;
  }
}
